import Vue from "vue";
import App from "./App.vue";

const elements = document.querySelectorAll(".mwf-form");

if (elements) {
  elements.forEach(element => {
    new Vue({
      render: createElement => {
        const context = {
          props: { ...element.dataset }
        };
        return createElement(App, context);
      }
    }).$mount(`#${element.id}`);
  });
}
